<template>
  <div
    class="w-full flex flex-col xl:flex-row gap-2 bg-untitled-gray-50 max-w-[2300px] mx-auto relative"
  >
    <div
      class="flex-1 flex flex-col gap-2 p-2 sm:p-4"
      :class="{
        'lg:border-r border-untitled-gray-300': show,
      }"
    >
      <!-- tabs -->
      <HomeMainTabs />
      <!-- end of tabs -->
      <div class="w-full">
        <component
          :is="display"
          :show-categories="selectedMainTab === 'playlist' ? false : true"
          :data="loadingDisplay"
        />
      </div>
    </div>
    <div class="w-full xl:w-2/6 flex flex-col gap-2 p-2 sm:p-4" v-if="show">
      <HomeRightSection />
    </div>
  </div>

  <EventDialog />
  <Teleport to="body">
    <LoadingFullScreen :disableMutation="true" :featuredContent="true" />
  </Teleport>
  <el-backtop :right="90" :bottom="90" />
</template>

<script setup>
import HomeMainTabs from "./partials/HomeMainTabs.vue";
import HomeRightSection from "./HomeRightSection.vue";
import { useHomeTabsStore } from "@/stores/home/useHomeTabs.store";

import { storeToRefs } from "pinia";
import { computed, defineAsyncComponent, onMounted } from "vue";
import { ref } from "vue";
// import { useAllAvailableCourseStore } from "@/stores/useAllAvailableCourse.store";
import { ElBacktop } from "element-plus";
import eventBus from "@/plugins/eventBus";
import LoadingFullScreen from "../utilities/loading/LoadingFullScreen.vue";
import FeaturedContent from "@/components/new-home/main-display/FeaturedContent.vue";
import LoadingHomeGridCourses from "../utilities/loading/LoadingHomeGridCourses.vue";
import LoadingHomeCategories from "../utilities/loading/LoadingHomeCategories.vue";
import { useLoadingStore } from "@/stores/utils/useLoading.store";
import EventDialog from "../events/EventDialog.vue";

const EnrolledCourses = defineAsyncComponent({
  loader: () => import("./main-display/EnrolledCourses.vue"),
  loadingComponent: LoadingHomeGridCourses,
  delay: 200,
  suspensible: false,
});

const LearningPath = defineAsyncComponent({
  loader: () => import("./main-display/LearningPath.vue"),
  loadingComponent: LoadingHomeGridCourses,
  delay: 200,
  suspensible: false,
});

const AvailableContent = defineAsyncComponent({
  loader: () => import("./main-display/AvailableContent.vue"),
  suspensible: false,
  delay: 200,
  loadingComponent: LoadingHomeCategories,
});

// const allAvailableCourseStore = useAllAvailableCourseStore();
const homeMainTabsStore = useHomeTabsStore();
const loadingStore = useLoadingStore();

const { selectedMainTab } = storeToRefs(homeMainTabsStore);
const show = ref(false);
const initialLoad = ref(true);

const loadingCourses = computed(() => loadingStore.shuffledCourses);
const loadingPlaylist = computed(() => loadingStore.shuffledPlaylist);
const loadingCategories = computed(() => loadingStore.shuffledCategories);

const loadingDisplay = computed(() => {
  if (selectedMainTab.value === "enrolled") {
    return loadingCourses.value;
  }
  if (selectedMainTab.value === "playlist") {
    return loadingPlaylist.value;
  }
  if (selectedMainTab.value === "content") {
    return loadingCategories.value;
  }
  return loadingCourses.value;
});

const display = computed(() => {
  if (selectedMainTab.value === "enrolled") {
    return EnrolledCourses;
  }
  if (selectedMainTab.value === "playlist") {
    return LearningPath;
  }
  if (selectedMainTab.value === "content") {
    return AvailableContent;
  }
  return FeaturedContent;
});

onMounted(() => {
  eventBus.$on("show-right-section", () => {
    if (!initialLoad.value) {
      return;
    }

    initialLoad.value = false;
    show.value = true;
  });
});
</script>

<style lang="scss" scoped></style>
